"use client"

import React, { createContext } from "react"
import type { CheckoutPreparedExpressType } from "types"
import { checkoutExpress } from "lib/api"
import { makeVar, useReactiveVar } from "@apollo/client"

export type ExpressCheckoutProviderType = {
  expressCheckoutState: ExpressCheckoutState
  setExpressCheckoutState: (state: Partial<ExpressCheckoutState>) => void
  handleExpressCheckout: () => void
}

export type ExpressCheckoutState = {
  loading: boolean
  error: string | null
  expressCheckout: CheckoutPreparedExpressType | null
  expressOrderSubmittedPaymentId: string | null
}

export const ExpressCheckoutContext =
  createContext<ExpressCheckoutProviderType>({} as ExpressCheckoutProviderType)

const expressCheckoutStateReactiveVar = makeVar<ExpressCheckoutState>({
  loading: true,
  error: null,
  expressCheckout: null,
  expressOrderSubmittedPaymentId: null,
})

export const ExpressCheckoutProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const expressCheckoutState = useReactiveVar(expressCheckoutStateReactiveVar)

  const setExpressCheckoutState = (state: Partial<ExpressCheckoutState>) =>
    expressCheckoutStateReactiveVar({
      ...expressCheckoutStateReactiveVar(),
      ...state,
    })

  const handleExpressCheckout = () => {
    setExpressCheckoutState({ loading: true })

    checkoutExpress()
      .then((expressCheckout) =>
        setExpressCheckoutState({ loading: false, expressCheckout })
      )
      .catch(() => {
        setExpressCheckoutState({ loading: false })
      })
  }

  return (
    <ExpressCheckoutContext.Provider
      value={{
        expressCheckoutState,
        setExpressCheckoutState,
        handleExpressCheckout,
      }}
    >
      {children}
    </ExpressCheckoutContext.Provider>
  )
}
